export default __webpack_public_path__ + "static/media/epl-banner-indo.f1c9e067.jpg";